import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';

export const useCancerQuoteResultPageParams = useQuoteOptionParams;
